module.exports = __webpack_public_path__ + "static/media/biomec.af6b8d17.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/tomate/climasense/aranha_roja_tomate/preventiva/biomec.png
// module id = 2385
// module chunks = 3